export enum Method {
  Get = "get",
  Post = "post",
  Put = "put",
  Delete = "delete",
}